module.exports = __webpack_public_path__ + "img/a.d1d3cd9a.png";